
(function () {
    'use strict';

    angular.module('newsListModule', [])
           .controller('NewsListController', NewsListController);

    NewsListController.$inject = ['$state', '$http', '$scope', '$timeout', '$window', 'newsService', 'tabStateService'];

    function NewsListController($state, $http, $scope, $timeout, $window, newsService, tabStateService) {
        var vm = this;
        vm.loadNews = loadNews;
        vm.toggleLoadAllNews = false;
        vm.news = [];
        vm.currentPage = -1;
        vm.startPage = -1;
        vm.totalResults = 0;
        vm.maxDisplayPage = NewsGridConfig.maxDisplayPage;
        vm.itemPerPage = HandbookConfiguration.NewsPageSize;
        vm.pageSize = HandbookConfiguration.NewsPageSize;
        vm.translation = {
            title: globalResources.CommonGridColumns.Title,
            createdDate: globalResources.CreatedDate,
            first: globalResources.First,
            last: globalResources.Last,
            description: globalResources.Description,
            publishedDate: globalResources.Published,
            ingress: globalResources.Ingress
        };

        vm.newsSetting = [];
        function newsSetting() {
            vm.newsSetting.push({ id: 'title', name: vm.translation.title, width: 35, coldefault: true });
            vm.newsSetting.push({ id: 'dtmPublish', name: vm.translation.publishedDate, width: '90px', coldefault: true });
            vm.newsSetting.push({ id: 'ingress', name: vm.translation.ingress, width: 60, coldefault: true });
        }

        initialize();

        function initialize() {
            getHeightGrid();
            newsSetting();
            loadAllNews($state.params.pageIndex);
        }

        function loadNews(id) {
            newsService
                .updateNewsReadCount(id)
                .then(function (result) {
                    $state.go(handbookActions.StartpageNews, { newsId: id, isPreview: false });
                });
        }

        function getInternetExplorerVersion() {
            var rv = -1;
            if (navigator.appName == 'Microsoft Internet Explorer') {
                var ua = navigator.userAgent;
                var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                    rv = parseFloat(RegExp.$1);
            }
            else if (navigator.appName == 'Netscape') {
                var ua = navigator.userAgent;
                var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                    rv = parseFloat(RegExp.$1);
            }
            return rv;
        }

		function isMobile() {
			try {
				if (/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
					return true;
				};
				return false;
			} catch (e) { console.log("Error in isMobile"); return false; }
		}

        function getHeightGrid() {
			var documentHeight = isMobile() ? window.innerHeight : $(window).height();
			var $gridTop = $('.table.gridStyle.margin-bottom-0');
			var top = ($gridTop.eq(0).offset() == null) ? 0 : $gridTop.eq(0).offset().top;
			var height = (documentHeight - top - 160);

			if (getInternetExplorerVersion() > -1) {
				angular.element('.scrollableTable').css('max-height', height + 'px');
			} else {
				angular.element('#gridController').css('max-height', height + 'px');
			}
        }

        $(window).on('resize', function () {
            getHeightGrid();
        });

        function loadAllNews(pageIndex, pageSize) {
            if (!pageIndex || pageIndex == -1) {
                pageIndex = 1;
            }
            if (pageIndex != vm.startPage) {
                user.currentNewsPage = pageIndex;
                newsService
                    .getNewsWithPaging(pageIndex - 1, pageSize || vm.pageSize)
                    .then(function (result) {
                        vm.news = result.data.news;
                        vm.totalResults = result.data.totalResults;
                        vm.currentPage = pageIndex;
                        vm.startPage = pageIndex;
                    });
            }
        }

        $scope.$watch('vm.currentPage', function (newPage) {
            if (vm.currentPage != -1) {
                loadAllNews(newPage);
            }
        });
    };
})();

